import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Controlling');

export const STOPTYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.StopType.Name')
    .required()
    .minLength(1)
    .maxLength(50)
    .build(),
  FieldBuilder
    .text('code', 'Entity.StopType.Code')
    .required()
    .minLength(1)
    .maxLength(10)
    .build(),
];

export const STOPTYPE_CONFIG = {
  entityName: 'StopType',
  localizationKey: 'Controlling::Entity.StopType',
  fields: STOPTYPE_FIELDS,
  permission: 'ControllingLiquidations.StopTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Liquidations + MENU_NAME_SUFFIX,
};
